import { useCallback, useState } from 'react';

import { useIntl } from 'react-intl';

import { usePaymentCheckoutRedesignExperiment } from 'experiments/use-payment-checkout-redesign-experiment';
import { sanitizeNumber } from 'utils/form';
import { initialErrorState, isGiftCardNumberValid } from 'utils/payment';

const isValidGiftCardNumberCheck = (newGiftCardNumber: string) =>
  isGiftCardNumberValid(sanitizeNumber(newGiftCardNumber));

export const useCardNumber = () => {
  const isPaymentRedesignEnabled = usePaymentCheckoutRedesignExperiment();
  const { formatMessage } = useIntl();
  const [giftCardNumber, setGiftCardNumber] = useState('');
  const [errors, setErrors] = useState(initialErrorState);
  const [isValidGiftCardNumber, setIsValidGiftCardNumber] = useState(false);

  const validateCardNumber = useCallback(
    (newGiftCardNumber: any) => {
      const isValid = isValidGiftCardNumberCheck(newGiftCardNumber);
      let giftCardNumberErrorMessage: string | undefined;
      if (!isValid) {
        giftCardNumberErrorMessage = newGiftCardNumber
          ? formatMessage({ id: 'giftCardNumberIsNotValid' })
          : formatMessage({ id: 'giftCardNumberIsRequired' });
      }
      setErrors(prevState => {
        return {
          ...prevState,
          giftCardNumber: giftCardNumberErrorMessage,
        };
      });
      setIsValidGiftCardNumber(isValid);
    },
    [formatMessage]
  );

  const handleCardNumberChange = useCallback(
    (newGiftCardNumber: any) => {
      const formattedNumber = sanitizeNumber(newGiftCardNumber);
      setGiftCardNumber(formattedNumber);
      if (!isPaymentRedesignEnabled) {
        validateCardNumber(formattedNumber);
      }
    },
    [isPaymentRedesignEnabled, validateCardNumber]
  );

  return {
    giftCardNumber,
    errors,
    isValidGiftCardNumber,
    handleCardNumberChange,
    isValidGiftCardNumberCheck,
    validateCardNumber,
  };
};
